import { Component, Injector } from '@angular/core';
import { FilterOptions, FilterBuilder, FilterComponent } from '@mango/core';
import { User } from './user';

@Component({
    selector: 'mtp-user-filter',
    templateUrl: './user-filter.component.html'
})
export class UserFilterComponent extends FilterComponent<User>  {

    constructor(injector: Injector) {
        super(injector, User, new FilterOptions<User>().like("name"));
    }

    ngOnInit() {
        super.ngOnInit();
    }
} 